/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["h2>h2,   h3>h3,   h4>h4{font-size:inherit;padding:0 1rem}  h4>h4{font-size:.7em}.group-bordered[_ngcontent-%COMP%]{border:1px solid #fff;margin-top:1rem;padding:0 1rem 1rem}.group-bordered__title[_ngcontent-%COMP%]{transform:translateY(-50%);background-color:#000;display:inline-block;font-size:1rem;font-family:r-montserrat,sans-serif;margin-bottom:0;color:#fff}.group-bordered__subtitle[_ngcontent-%COMP%]{font-family:r-montserrat,sans-serif;font-weight:700;font-size:.9rem;margin-bottom:.8rem;color:var(--main-color);text-transform:uppercase}"];
export { styles as styles };
